/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { atcb_action as ATCB_ACTION } from 'add-to-calendar-button';
// import 'add-to-calendar-button/assets/css/atcb.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import {
  EventHighlightFeature,
  WShare,
  FeatureIcon,
  FeatureIconCard,
  FeatureIconImg,
} from './styles/EventsHighlightsBlock.styled';
import { Container } from './styles/Container.styled';
import SocialMediaFloatingButtons from './SocialMediaFloatingButtons';
import {
  EventDescriptionDetails,
  ArticleDescription,
  Figure,
  DescriptionText,
  ReadMoreLabel,
  TextToggle,
  AudienceIcon,
} from './styles/EventDescription.styled';
import { Row } from './styles/Row.styled';
import {
  Column,
  ColumnFiveLgSixMdFul,
  ColumnXlSixLgFiveMdFour,
  ColumnXlSixLgSevenMdEight,
} from './styles/Column.styled';
import { DescriptonCTA, ButtonFlex, WebSiteEvent } from './styles/EventCTA.styled';
import { LoadMoreButton } from './styles/LoadMoreButton.styled';
import { Button } from './styles/Button.styled';
import TimeIcon from '../assets/svg/time.svg';
import LocationIcon from '../assets/svg/ico-location.svg';
import EventIcon from '../assets/svg/event-type.svg';
import IndustryIcon from '../assets/svg/industry.svg';
import { convertMonthToAr, startEndDateToString } from '../helpers/date-convert';
import EventsDetailsSocialLinks from './EventsDetailsSocialLinks';
import ImageBanner from './ImageBanner';
import BreadcrumbBackTo from './BreadcrumbBackTo';
import { convertHtmlIntoArray } from '../helpers/array-generator';
import InsightsSlider from './InsightsSlider';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import venuesHandler from '../helpers/venues-handler';
import ImageCarousel from './ImageCarousel';
import Events from '../services/Events';
import WhatsHappeningSameMonth from './WhatsHappeningSameMonth';

export default function EventsDetails({ data, dir }) {
  const { translations } = useContext(DWTCContext);
  const bannerData = {
    title: data.title,
    image: data.heroImage,
    text: '',
    next: false,
    prev: false,
    jumpToSection: '#breadcrumbBackTo',
  };

  const isArabic = dir === 'rtl';
  const lang = isArabic ? 'ar' : 'en';
  const events = new Events();
  const eventList = events.get(lang);
  eventList.sort((a, b) => {
    if (a.title < b.title) return -1;
    if (a.title > b.title) return 1;
    return 0;
  });
  eventList.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

  const eventIndex = eventList.findIndex((event) => event.url === data.url);
  const nextEvent = eventList.filter((event, index) => eventIndex > index).reverse()[0];
  const prevEvent = eventList.filter((event, index) => eventIndex < index)[0];

  const insightsSliderData = {
    title: 'Industry Insights',
    parentLink: { url: `/en/industry-insights`, name: 'View All' },
  };

  const [htmlContent, setHtmlContent] = React.useState([]);
  const [toggleText, setToggleText] = React.useState(false);
  const eventSettings = {
    iCalFileName: data.title,
    name: data.title,
    description: data.description,
    location: data.location,
    startDate: new Date(data.startDate).toISOString().substring(0, 10),
    endDate: new Date(data.endDate).toISOString().substring(0, 10),
    timeZone: 'Asia/Dubai',
    options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo'],
    trigger: 'click',
  };

  const handleCalendarClick = () => ATCB_ACTION(eventSettings);

  const textLess = getTranslationByKey(translations, '-Read Less');
  const textMore = getTranslationByKey(translations, '+Read More');

  const backToEventList = getTranslationByKey(translations, 'Back to event list');
  const [label, setLabel] = React.useState(textMore);

  // React.useEffect(() => ATCB_INIT());

  React.useEffect(() => setLabel(toggleText ? textLess : textMore), [toggleText]);

  React.useEffect(() => {
    if (data.pageContent) {
      const alphaNumRegEx = /[\u0600-\u06FF]/gi;
      if (isArabic && alphaNumRegEx.test(data.pageContent)) {
        setHtmlContent(convertHtmlIntoArray(data.pageContent));
      }
      if (!isArabic) {
        setHtmlContent(convertHtmlIntoArray(data.pageContent));
      }
    }
  }, []);
  const organisedBy = dir === 'rtl' ? 'تنظيم: ' : 'Organised By:';
  const addToCalendar = dir === 'rtl' ? 'أضف إلي أجندة مواعيدي' : 'Add to my calendar';

  const handleEventVenues = (venues) => venuesHandler(venues, translations);

  const handleLogo = (enLogo, arLogo) => {
    if (isArabic && !isEmpty(arLogo)) {
      return (
        <LazyLoadImage
          src={arLogo.url}
          alt={arLogo.name}
          effect="blur"
          placeholderSrc={`${arLogo.url}?width=50&quality=50`}
        />
      );
    }
    if (!isEmpty(enLogo))
      return (
        <LazyLoadImage
          src={enLogo.url}
          alt={enLogo.name}
          effect="blur"
          placeholderSrc={`${enLogo.url}?width=50&quality=50`}
        />
      );
    return null;
  };

  return (
    <div className="innerContent event_detailswrapper">
      <ImageBanner
        data={{
          ...bannerData,
          next: { url: isEmpty(nextEvent) ? '#' : nextEvent.url },
          prev: { url: isEmpty(prevEvent) ? '#' : prevEvent.url },
        }}
        id={data.id}
        dir={dir}
        arrow
      />
      <SocialMediaFloatingButtons noPadding dir={dir} />
      <BreadcrumbBackTo
        dir={dir}
        data={{ link: { url: isArabic ? '/ar/events' : '/en/events', name: backToEventList } }}
      />
      <EventHighlightFeature className="event_detailshighlight innerContent">
        <Container>
          <WShare dir={dir}>
            <FeatureIcon dir={dir}>
              <FeatureIconCard dir={dir}>
                <FeatureIconImg className="ftime">
                  <TimeIcon dir={dir} />
                </FeatureIconImg>
                <p dir={dir} className="fcaption">
                  {getTranslationByKey(translations, 'Time & Date')}
                </p>
                <time dir={dir} className="edate">
                  {isArabic
                    ? convertMonthToAr(startEndDateToString(data.startDate, data.endDate))
                    : startEndDateToString(data.startDate, data.endDate)}
                </time>
                <p dir={dir} className="flocation" />
              </FeatureIconCard>
            </FeatureIcon>
            {!isEmpty(data.eventVenues) ? (
              <FeatureIcon dir={dir}>
                <FeatureIconCard dir={dir}>
                  <FeatureIconImg className="location">
                    <LocationIcon />
                  </FeatureIconImg>
                  <p dir={dir} className="fcaption">
                    {getTranslationByKey(translations, 'Location')}
                  </p>
                  {handleEventVenues(data.eventVenues, translations).map((value, index, arr) => (
                    <p dir={dir} className="flocation">
                      {index !== arr.length - 1 ? `${value}${isArabic ? ' ' : ','} ` : value}
                    </p>
                  ))}
                </FeatureIconCard>
              </FeatureIcon>
            ) : data.location ? (
              <FeatureIcon dir={dir}>
                <FeatureIconCard dir={dir}>
                  <FeatureIconImg className="location">
                    <LocationIcon />
                  </FeatureIconImg>
                  <p dir={dir} className="fcaption">
                    {getTranslationByKey(translations, 'Location')}
                  </p>
                  <p dir={dir} className="flocation">
                    {data.location}
                  </p>
                </FeatureIconCard>
              </FeatureIcon>
            ) : null}
            {isEmpty(data.eventType) || (
              <FeatureIcon dir={dir}>
                <FeatureIconCard dir={dir}>
                  <FeatureIconImg className="evtype">
                    <EventIcon />
                  </FeatureIconImg>
                  <p dir={dir} className="fcaption">
                    {getTranslationByKey(translations, 'Event Type')}
                  </p>
                  {data.eventType.map((value, index) => (
                    <p dir={dir} className="flocation">
                      {`${getTranslationByKey(translations, value)}${
                        data.eventType.length - 1 !== index ? `${isArabic ? ' ' : ';'}` : ''
                      }`}
                    </p>
                  ))}
                </FeatureIconCard>
              </FeatureIcon>
            )}
            {isEmpty(data.eventSectors) || (
              <FeatureIcon dir={dir}>
                <FeatureIconCard dir={dir}>
                  <FeatureIconImg className="exhib">
                    <IndustryIcon />
                  </FeatureIconImg>
                  <p dir={dir} className="fcaption">
                    {getTranslationByKey(translations, 'Industry')}
                  </p>
                  {data.eventSectors.map((value, index) => (
                    <p dir={dir} className="flocation">
                      {`${getTranslationByKey(translations, value)}${
                        data.eventSectors.length - 1 !== index ? `${isArabic ? ' ' : ';'}` : ''
                      }`}
                    </p>
                  ))}
                </FeatureIconCard>
              </FeatureIcon>
            )}

            {isEmpty(data.eventAudiences) || (
              <FeatureIcon dir={dir}>
                <FeatureIconCard dir={dir}>
                  <FeatureIconImg className="audience">
                    <AudienceIcon />
                  </FeatureIconImg>
                  <p dir={dir} className="fcaption">
                    {getTranslationByKey(translations, 'Audience')}
                  </p>
                  <p dir={dir} className="flocation">
                    {getTranslationByKey(translations, data.eventAudiences)}
                  </p>
                </FeatureIconCard>
              </FeatureIcon>
            )}
          </WShare>
        </Container>
      </EventHighlightFeature>

      <EventDescriptionDetails>
        <Container>
          <ArticleDescription dir={dir}>
            <Row className="article_description">
              <ColumnFiveLgSixMdFul>
                <Figure dir={dir}>
                  {handleLogo(data.eventLogo, data.eventArabicLogo)}
                  <figcaption>
                    {organisedBy} <span>{data.eventOrganiser}</span>
                  </figcaption>
                </Figure>
              </ColumnFiveLgSixMdFul>
              <Column>
                <DescriptionText dir={dir}>
                  {htmlContent.map((text, index) => (
                    <TextToggle
                      toggle={index && toggleText}
                      className={index && 'toggle'}
                      dir={dir}
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  ))}
                </DescriptionText>
                <ReadMoreLabel
                  toggle={toggleText}
                  onClick={() => setToggleText(!toggleText)}
                  dir={dir}
                >
                  {label}
                </ReadMoreLabel>
              </Column>
            </Row>
          </ArticleDescription>
        </Container>
      </EventDescriptionDetails>
      <DescriptonCTA>
        <Container>
          <Row>
            <ColumnXlSixLgFiveMdFour className="justify_cntr">
              <LoadMoreButton className="btn_eventcta" dir={dir} onClick={handleCalendarClick}>
                {addToCalendar}
              </LoadMoreButton>
            </ColumnXlSixLgFiveMdFour>

            <ColumnXlSixLgSevenMdEight className="justify_cntr">
              <ButtonFlex className="eventwebdesc" dir={dir}>
                <WebSiteEvent>
                  {data.websiteURL && (
                    <Button
                      to={data.websiteURL}
                      target="_blank"
                      stylevariant="black"
                      className="btn_eventcta"
                      dir={dir}
                    >
                      {getTranslationByKey(translations, 'Visit Event Website')}
                    </Button>
                  )}
                </WebSiteEvent>

                <EventsDetailsSocialLinks data={data} dir={dir} />
              </ButtonFlex>
            </ColumnXlSixLgSevenMdEight>
          </Row>
        </Container>
      </DescriptonCTA>
      {isEmpty(data.imagesCarousel) || (
        <ImageCarousel data={{ carouselImages: data.imagesCarousel }} dir={dir} />
      )}
      <WhatsHappeningSameMonth
        dir={dir}
        eventMonth={new Date(data.startDate).getMonth() + 1}
        eventYear={new Date(data.startDate).getFullYear()}
      />
      {isArabic || (
        <InsightsSlider
          dir={dir}
          data={{
            ...insightsSliderData,
            relatedEventSectors: data.eventSectors,
            isEvent: true,
            itemsLimit: 12,
          }}
        />
      )}
    </div>
  );
}
